/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import moment from 'moment';
import UpdateModal from '../components/UpdateModal';
import * as actions from '../action';
import * as c from '../constant';

import FeesTaggingContainer from './FeesTaggingContainer';

function DiscountPenaltyContainer({
  getDiscountPenaltyList,
  discountPenaltyList,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getDiscountPenaltyList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleEdit = data => e => {
    e.preventDefault();

    const args = {
      ...data.attributes,
      date_before_penalty_start: moment(
        _.get(data, 'attributes.date_before_penalty_start')
      ).format('MM/DD/YYYY'),
      last_date_with_discount: moment(
        _.get(data, 'attributes.last_date_with_discount')
      ).format('MM/DD/YYYY'),
    };

    setModal({
      isOpen: true,
      content: <UpdateModal updateList={args} />,
      title: 'Update Discount and Penalty',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6 p-3">
              <h3>Discount and Penalty</h3>
            </div>
            <div className="col-6 d-flex">
              <button
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold ml-auto px-4 mr-1"
                onClick={handleEdit(discountPenaltyList)}
              >
                Update
              </button>
            </div>
            <div className="col-12 d-flex align-items-center justify-content-center">
              <div style={{ width: '90%' }}>
                <table className="table table-bordered transaction-table">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">Year</div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>{_.get(discountPenaltyList, 'attributes.year')}</b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="text-dark vertical-align-center"
                        width="350"
                      >
                        <div className="pl-3 py-2">
                          Additional Monthly Penalty Percentage
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.additional_monthly_penalty_percentage'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">Discount Percentage</div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.discount_percentage'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">
                          Maximum Penalty Percentage
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.maximum_penalty_percentage'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">
                          Month Day Before Penalty Update
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.month_day_before_penalty_update'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">
                          Initial Penalty Percentage
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.initial_penalty_percentage'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">
                          Date Before Penalty Start
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {moment(
                              _.get(
                                discountPenaltyList,
                                'attributes.date_before_penalty_start'
                              )
                            ).format('MM/DD/YYYY')}
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">Last Date with Discount</div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {moment(
                              _.get(
                                discountPenaltyList,
                                'attributes.last_date_with_discount'
                              )
                            ).format('MM/DD/YYYY')
                            // _.get(discountPenaltyList, 'attributes.last_date_with_discount')
                            }
                          </b>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="350">
                        <div className="pl-3 py-2">
                          Gross Additional Percentage
                        </div>
                      </td>
                      <td width="350" className="text-right">
                        <div className="pr-3 py-2">
                          <b>
                            {_.get(
                              discountPenaltyList,
                              'attributes.gross_additional_percentage'
                            )}
                          </b>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FeesTaggingContainer />
    </div>
  );
}

DiscountPenaltyContainer.propTypes = {
  getDiscountPenaltyList: PropTypes.instanceOf(Function).isRequired,
  discountPenaltyList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  discountPenaltyList: _.get(api, `${c.GET_DISCOUNT_PENALTY_LIST}.item`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DiscountPenaltyContainer);
